import React, { useState } from 'react';
import './NewExpense.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import { width } from '@fortawesome/free-solid-svg-icons/fa0';

export default function NewExpense() {
    const [mensaje, setMensaje] = useState('');
    const [amount, setAmount] = useState('');
    const [description, setDescription] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setAmount('');
        setDescription('');
        setMensaje('');
        setModalOpen(!modalOpen);
    };


    const crear = async () => {
        const formData = new FormData();
        formData.append('amount', amount);
        formData.append('description', description);

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/expensePost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                toggleModal();
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>+</span> Agregar
            </button>
            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Gastos</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form className='flexGrap'>
                            <fieldset>
                                <legend>Cantidad</legend>
                                <input
                                    type='number'
                                    placeholder='Cantidad'
                                    name='amount'
                                    value={amount}
                                    step="0.1"
                                    min="0"
                                    onChange={(e) => setAmount(e.target.value)}
                                />
                            </fieldset>
                            <fieldset className='w-100'>
                                <legend>Descripción</legend>
                                <textarea 
                                    type='text'
                                    name='description'
                                    placeholder='Descripción'
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </fieldset>
                            {mensaje ? (
                                <button type='button' className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
